export const SHOW_MODAL = 'zola/modal/SHOW_MODAL';
export const HIDE_MODAL = 'zola/modal/HIDE_MODAL';
export const IS_BUSY = 'zola/modal/IS_BUSY';
